import { motion } from "framer-motion";
import { PROJECTS } from "../../lib/data";

export default function Portfolio() {
    return (
        <section
            data-testid="portfolio-section"
            id="portfolio"
            className="relative py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
                    <div>
                        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
                            Selected work
                        </div>
                        <h2 className="font-display font-light text-4xl md:text-5xl tracking-tighter leading-tight max-w-2xl">
                            Products we&apos;ve shipped with{" "}
                            <span className="italic font-medium">care</span>.
                        </h2>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
                    {PROJECTS.map((p, i) => (
                        <motion.article
                            key={p.title}
                            initial={{ opacity: 0, y: 18 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ delay: i * 0.05 }}
                            data-testid={`project-card-${i}`}
                            className={`group relative overflow-hidden rounded-2xl border border-border bg-card hover:-translate-y-1 transition-all duration-500 hover:calm-glow ${p.span}`}
                        >
                            <div className="relative aspect-[16/10] overflow-hidden bg-secondary">
                                <img
                                    src={p.image}
                                    alt={p.title}
                                    className="w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-700"
                                    loading="lazy"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-foreground/20 via-transparent to-transparent" />
                            </div>
                            <div className="p-6 md:p-8">
                                <div className="flex flex-wrap items-center gap-2 mb-4">
                                    {p.stack.map((s) => (
                                        <span
                                            key={s}
                                            className="text-[11px] uppercase tracking-wider px-2.5 py-1 rounded-full border border-border text-muted-foreground"
                                        >
                                            {s}
                                        </span>
                                    ))}
                                </div>
                                <h3 className="font-display text-2xl md:text-3xl tracking-tight mb-3">
                                    {p.title}
                                </h3>
                                <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                                    {p.summary}
                                </p>
                                <div className="mt-5 flex items-center justify-between gap-4 flex-wrap">
                                    <div className="text-sm">
                                        <span className="text-muted-foreground">
                                            Outcome —{" "}
                                        </span>
                                        <span className="font-medium">
                                            {p.outcome}
                                        </span>
                                    </div>
                                    {p.url && (
                                        <a
                                            href={p.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-xs uppercase tracking-widest px-4 py-2 rounded-full border border-border text-muted-foreground hover:text-foreground hover:border-foreground transition-colors duration-200"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            Visit site ↗
                                        </a>
                                    )}
                                </div>
                            </div>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
